import React, { useContext } from "react";
import { DishesContext } from "../../context/dishes";
import Bestdeals from "../BestDeals";
import {FiltersWrapper} from '../Layout/FiltersWrapper';

export const Filters = () => {
  const {
    filters: { search, price },
    update_filters,
    category,
    bestdeals,
    phone_screen
  } = useContext(DishesContext);
  return (
    <FiltersWrapper>


      <div className="select-control mb-1 mt-5">


          <span className="bold-text">Sort by:</span>
        <select
          value={category}
          onChange={update_filters}
          name="category"
          className="select-form"
          id="category"
        >
          <option value="all">all</option>
          <option value="Spicy">Spicy</option>
          <option value="Vegan">Vegan</option>
          <option value="Sweet">Sweet</option>
        </select>
        
      </div>



      <div className="mt-5">
        <input
          name="search"
          value={search}
          onChange={update_filters}
          placeholder="Search dishes"
          type="text"
          className="input-search"
        />
      </div>

      <div className="mt-5">
        <h5 className="light-text">Filter by price</h5>

        <div className="border-line"></div>

        <div className="filters-container">
          <div className="form-check">
            <label className="container-radio">
              <input
                name="price"
                onChange={update_filters}
                value="all"
                checked={price === "all"}
                type="radio"
              />
              <span className="checkmark"></span>
              <span className="ml-3">All</span>
            </label>
          </div>

          <div className="form-check">
            <label className="container-radio">
              <input
                name="price"
                onChange={update_filters}
                value="0"
                checked={price === 0}
                type="radio"
              />
              <span className="checkmark"></span>
              <span className="ml-3">$0 - 10</span>
            </label>
          </div>

          <div className="form-check">
            <label className="container-radio">
              <input
                name="price"
                onChange={update_filters}
                value="10"
                checked={price === 10}
                type="radio"
              />
              <span className="checkmark"></span>
              <span className="ml-3">$10 - 20</span>
            </label>
          </div>


            <div className="form-check">
            <label className="container-radio">
              <input
                name="price"
                onChange={update_filters}
                value="20"
                checked={price === 20}
                type="radio"
              />
              <span className="checkmark"></span>
              <span className="ml-3">Above $20</span>
            </label>
          </div>
          
        </div>

        { !phone_screen && 
         <div className="mt-5">
          <h5 className="light-text">Best Deals</h5>
          {bestdeals.map((item) => {
            return <Bestdeals key={item.id} {...item} />;
          })}
        </div>
        }
      </div>
    </FiltersWrapper>
  );
};

export { Filters as default };
